<template>
  <div id="home">Home</div>
  
  <main>
    <header>
      <NavBar></NavBar>
    </header>
    <VideoPlayer></VideoPlayer>
    <ProfessionalProjects></ProfessionalProjects>
    <PersonalProjects></PersonalProjects>
    <AboutPage></AboutPage>
    <SkillsPage></SkillsPage>
    <ProfessionalExperience></ProfessionalExperience>
    <EducationPage></EducationPage>
    <ContactPage></ContactPage>
  </main>

  <FooterPage></FooterPage>
</template>

<script setup>
import { onMounted } from 'vue';
import NavBar from './components/NavBarComponent.vue'
import VideoPlayer from './components/VideoPlayer.vue'
import ProfessionalProjects from './components/ProfessionalProjects.vue'
import PersonalProjects from './components/PersonalProjects.vue'
import AboutPage from './components/AboutPage.vue'
import SkillsPage from './components/SkillsPage.vue'
import ProfessionalExperience from './components/ProfessionalExperience.vue'
import EducationPage from './components/EducationPage.vue'
import ContactPage from './components/ContactPage.vue'
import FooterPage from './components/FooterPage.vue';

onMounted(() => {
  document.title = 'Jérffeson Jésus - Unity Programmer and Game Designer';
});
</script>

<style>
@import '~/src/assets/css/global/global.scss';
@import '~/src/assets/css/global/carousel.scss';
@import '~/src/assets/css/global/fonts.scss';
</style>
